import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import Typography from '@mui/material/Typography';
import { useAppSelector } from '../../../redux/store';
import { FormControlContainer } from '../../formControlContainer';
import { ThemeRoomBackgroundControls } from '../../themes/themeRoomBackgroundControls';
import { ThemeTableColorControls } from '../../themes/themeTableColorControls';
export const ThemeSettingsContainer = () => {
    const isPokerScene = useAppSelector((state) => state.scene.roomSceneType === 'poker');
    if (isPokerScene) {
        return (_jsxs(_Fragment, { children: [_jsx(ThemeRoomBackgroundControls, { isSelfPanel: false }), _jsx(ThemeTableColorControls, { isSelfPanel: false })] }));
    }
    return (_jsx(FormControlContainer, { children: _jsx(Typography, { component: 'div', children: "Table theme can be changed in a poker room." }) }));
};
